const cleanSpaceRegex = /\s{2,}/g;
function cleanTextSearchInput(text) {
  return text.replace(cleanSpaceRegex, " ").trim().toLowerCase();
}

export { cleanTextSearchInput };
